import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, CheckCircle2Icon } from 'lucide-react';
const beforeItems = ['Sin energía', 'Problemas digestivos', 'Pelo opaco', 'Baja vitalidad'];
const afterItems = ['Más energía', 'Mejor digestión', 'Pelo brillante', 'Mayor vitalidad y calidad de vida'];
export function BeforeAfterSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-21">
      <div className="max-w-3xl mx-auto" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-23">
          <h2 className="text-3xl md:text-5xl font-bold text-charcoal font-serif leading-tight" data-id="element-24">
            La alimentación <span className="text-primary" data-id="element-25">lo cambia todo</span>
          </h2>
        </motion.div>

        <div className="flex flex-col gap-8" data-id="element-26">
          {/* ANTES Card */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-red-50 rounded-2xl overflow-hidden border border-red-100" data-id="element-27">
            <div className="relative w-full overflow-hidden" data-id="element-28">
              <img src="https://cdn.magicpatterns.com/uploads/vb5sSpCPPcgue4CRjA1Z4Z/gggg.png" alt="Antes - perro sin energía con alimento procesado" className="w-full max-h-[280px] md:max-h-[340px] object-cover" data-id="element-29" />
              <div className="absolute top-4 left-4 px-4 py-1.5 bg-red-500 text-white text-sm font-extrabold uppercase tracking-wider rounded-full shadow-md" data-id="element-30">
                Antes
              </div>
            </div>

            <div className="p-6" data-id="element-31">
              <ul className="space-y-3" data-id="element-32">
                {beforeItems.map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-33">
                    <XCircleIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-34" />
                    <span className="text-gray-700 font-medium text-base" data-id="element-35">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.div>

          {/* Arrow / Divider */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.5
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: 0.2
        }} className="flex justify-center -my-4 relative z-10" data-id="element-36">
            <div className="w-14 h-14 rounded-full bg-primary flex items-center justify-center shadow-lg" data-id="element-37">
              <svg className="w-7 h-7 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-38">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 14l-7 7m0 0l-7-7m7 7V3" data-id="element-39" />
              </svg>
            </div>
          </motion.div>

          {/* DESPUÉS Card */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.15
        }} className="bg-green-50 rounded-2xl overflow-hidden border border-green-200" data-id="element-40">
            <div className="relative w-full overflow-hidden" data-id="element-41">
              <img src="https://cdn.magicpatterns.com/uploads/ttedP14LRB7P7Bx4hUSxvZ/x.png" alt="Después - perro feliz y activo con comida natural" className="w-full max-h-[280px] md:max-h-[340px] object-contain bg-green-50" data-id="element-42" />
              <div className="absolute top-4 left-4 px-4 py-1.5 bg-primary text-white text-sm font-extrabold uppercase tracking-wider rounded-full shadow-md" data-id="element-43">
                Después
              </div>
            </div>

            <div className="p-6" data-id="element-44">
              <ul className="space-y-3" data-id="element-45">
                {afterItems.map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-46">
                    <CheckCircle2Icon className="w-5 h-5 text-primary flex-shrink-0" data-id="element-47" />
                    <span className="text-gray-700 font-medium text-base" data-id="element-48">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}